/* eslint-disable max-nested-callbacks */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* istanbul ignore file */
/* eslint-disable no-case-declarations, no-inner-declarations */
import _ from 'lodash';
import {beforeMainLoader, completeMainLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import * as analytics from '@sinclair-digital/stl-common/src/analytics/common';
import clipCardTemplate from '../templates/media/clipCard.hbs';
import segmentsPanel from '../templates/media/segmentsPanel.hbs';
import videoThumbsTemplate from '../templates/media/videoThumbs.hbs';
import {makesClip, makesInstantClip} from '@sinclair-digital/stl-common/src/analytics/mediaPackage';
import eventChannels from '@sinclair-digital/stl-common/src/eventChannels';
import $ from 'jquery';
import moment from 'moment';
import 'jquery-ui';
import vidsvcs from '../external/vidsvcs.js';
import {fetchJson} from '@sinclair-digital/sbg-util/dist/es/fetch';
import {fetch as BBFetch} from '@sinclair-digital/stl-common/src/backboneHelpers';
import MediaModel from '@sinclair-digital/stl-common/src/models/media/mediaModel';

const state = {
    segmentStories: [],
    lastEngagedSegment: undefined,
};

const fetchSegments = broadcastId => fetchJson(`https://autoclip.sinclairdigitallabs.com/asset/${broadcastId}`);
const formatDuration = (minutes = '', seconds = '') => `${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;

const JWPlayerState = {
    idle: 'idle',
    buffering: 'buffering',
    playing: 'playing',
    paused: 'paused',
};

// https://support.jwplayer.com/articles/how-to-add-preview-thumbnails#vtt-example
const generateVTT = thumbs => {
    const vtt = thumbs.reduce((acc, thumb, index) => {
        let newEntry = index !== 0 ? '\n\n' : '';
        newEntry += `${thumb.from} --> ${thumb.to}`;
        newEntry += `\n${thumb.url}`;
        return acc + newEntry;
    }, 'WEBVTT ');

    return vtt;
};

export const formatHHMMSS = seconds => moment.utc(
    moment.duration(seconds * 1000).asMilliseconds()
).format(moment.HTML5_FMT.TIME_MS);

// potential issue with non-ascii strings, but this is unlikely in this instance
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
export const base64Encode = string => {
    try {
        const base64String = btoa(string);
        return base64String;
    } catch {
        return null;
    }
};

export const decimalToHexString = dec => {
    const number = dec < 0 ? 0xffffffff + dec + 1 : dec;
    return number.toString(16).toUpperCase();
};

const generateThumbnails = ({duration, slice_dur, thumb_prefix}) => {
    let i = 0;
    const thumbCount = Math.floor(duration / slice_dur);
    const thumbs = [];

    while (i < thumbCount) {
        const hexSlice = decimalToHexString(i).padStart(8, '0');
        const timecode = i * slice_dur;

        const thumb = {
            url: thumb_prefix + hexSlice + '.jpg',
            timecode,
            from: formatHHMMSS(timecode),
            to: i !== thumbCount - 1
                ?  formatHHMMSS((i + 1) * slice_dur)
                : formatHHMMSS(duration),
        };

        thumbs.push(thumb);
        i = i + 1;
    }
    return thumbs;
};

export const clipping = {
    init(opts) {
        Object.assign(this, opts);
        this.vidsvcs = vidsvcs();
    },
    _videoWindowResize() {
        const remainderHeight = $('.video-scale-wrapper').height() + $('.video-editor-bottom').outerHeight();
        $('.sda-media-editor').height($('.video-editor-wrapper').height() - remainderHeight);
    },
    videoScrubScale: 1,
    //set scale and move all pieces based on scale
    _setVideoScalePos(opts, oHeight, oWidth) {
        const context = this;
        const scaleOpts = context._getDragOpts('scale');
        const scrubOpts = context._getDragOpts('scrub');
        const scale = (scaleOpts.$center.width() + 58) / scaleOpts.$container.width();
        context.videoScrubScale = scale;

        const clipScale = scrubOpts.$scaleBlock.width() / scrubOpts.$handle.attr('data-duration');
        if (($('.video-clipping-thumb').width() / 16) * 9 > 40) {
            $('.video-clipping-thumb').height(($('.video-clipping-thumb').width() / 16) * 9);
        } else {
            $('.video-clipping-thumb').height(40);
        }

        scaleOpts.$scaleBlock.width(oWidth / scale);

        scrubOpts.$dragger
            .css('left', scrubOpts.$dragger.attr('data-left') / scale)
            .width(scrubOpts.$dragger.attr('data-width') / scale);

        scrubOpts.$right.css('left', scrubOpts.$right.attr('data-left') / scale);
        const rightShadeWidth =
            scrubOpts.$scaleBlock.width() -
            (context._getLeftPos(scrubOpts.$right) + context._getLeftPos(scrubOpts.$dragger) + 7.5);
        scrubOpts.$rightShade
            .css('left', context._getLeftPos(scrubOpts.$dragger) + context._getLeftPos(scrubOpts.$right) + 7.5)
            .width(rightShadeWidth);

        scrubOpts.$left.css('left', scrubOpts.$left.attr('data-left') / scale);

        scrubOpts.$leftShade.width(context._getLeftPos(scrubOpts.$dragger) + 7.5);

        if (context.playerState !== 'play') {
            scrubOpts.$handle.css('left', scrubOpts.$handle.attr('data-time') * clipScale);
        }

        scrubOpts.$center.width(context._getLeftPos(scrubOpts.$right) - context._getLeftPos(scrubOpts.$left));

        scaleOpts.$scaleBlock
            .parent()
            .scrollLeft((context._getLeftPos(scaleOpts.$left) + context._getLeftPos(scaleOpts.$dragger)) / scale);

        scaleOpts.$center.find('.control-bar-value').html(Math.round(100 + (100 - scale * 100)) + '%');
        context._videoWindowResize();
    },
    //set start pos data attr for scaling
    _scaleScrubBar(opts) {
        const context = this;
        opts.$dragger.attr({
            'data-width': opts.$dragger.width() * context.videoScrubScale,
            'data-left': parseInt(opts.$dragger.css('left'), 10) * context.videoScrubScale,
        });
        opts.$right.attr({
            'data-width': opts.$dragger.width(),
            'data-left': parseInt(opts.$right.css('left'), 10) * context.videoScrubScale,
        });
        opts.$center.attr({
            'data-width': opts.$center.width() * context.videoScrubScale,
        });
        opts.$leftShade.attr({
            'data-width': opts.$center.width() * context.videoScrubScale,
        });
        opts.$leftShade.attr({
            'data-width': opts.$dragger.width(),
            'data-left': parseInt(opts.$right.css('left'), 10) * context.videoScrubScale,
        });
        opts.$handle.attr({
            'data-width': opts.$dragger.width(),
            'data-left': context._getLeftPos(opts.$handle) * context.videoScrubScale,
        });
    },
    getClipScale(){
        return this.clipDuration / $('.scale-block').width();
    },
    setStartTime(value){
        $('#startTime').val(value);
        $('.scrub-control-bar-left-marker').attr('data-time', value);
    },
    setEndTime(value){
        $('#endTime')
            .sdaRemoveError()
            .val(value);
        $('.scrub-control-bar-right-marker').attr('data-time', value);
    },
    _getLeftPos($el) {
        return $el.position().left;
    },
    _initScrubBar() {
        const context = this;
        const container = '.scale-block';
        const $container = $(container);
        const result = $.Deferred();
        const opts = {
            $scaleContainer: $('.video-scrub-control-bar'),
            $right: $container.find('.scrub-control-bar-right-marker'),
            $left: $container.find('.scrub-control-bar-left-marker'),
            $center: $container.find('.scrub-control-bar-center'),
            $dragger: $container.find('.scrub-control-bar-drag'),
            $scaleBlock: $('.scale-block'),
            $leftShade: $container.find('.scrub-left-shade'),
            $rightShade: $container.find('.scrub-right-shade'),
            $handle: $('.scrub-control-bar-handle'),
        };

        context.videoScrubOpts = opts;

        opts.$right.draggable({
            axis: 'x',
            containment: container,
            start() {},
            drag(event, ui) {
                const markerLeftPos = ui.position.left;
                opts.$center.css({width: markerLeftPos});
                opts.$dragger.width(markerLeftPos + opts.$right.width());

                opts.$rightShade.css({
                    left: markerLeftPos + context._getLeftPos(opts.$dragger) + 7.5,
                    width: opts.$scaleContainer.width() - (markerLeftPos + context._getLeftPos(opts.$dragger) + 7.5),
                });

                const clipScale = context.getClipScale.call(context);
                const value = clipScale * (markerLeftPos + context._getLeftPos(opts.$dragger) + 4.5);

                context.setEndTime(value);
            },
            stop() {
                context._scaleScrubBar(opts);
            },
        });
        opts.$left.draggable({
            axis: 'x',
            containment: container,
            start() {},
            drag(event, ui) {
                const markerLeftPos = ui.position.left;
                const rightMarkerLeftPos = opts.$right.position().left;

                opts.$center.width(rightMarkerLeftPos - markerLeftPos).css('left', markerLeftPos);
                opts.$leftShade.width(markerLeftPos + parseInt(opts.$dragger.css('left'), 10) + 7.5);
                const clipScale = context.getClipScale.call(context);
                const value = clipScale * (markerLeftPos + 4.5 + context._getLeftPos(opts.$dragger));

                context.setStartTime(value);
            },
            stop(event, ui) {
                const markerLeftPos = ui.position.left;
                const draggerPosLeft = opts.$dragger.position().left;

                opts.$dragger
                    .width(opts.$left.width() + opts.$right.width() + opts.$center.width())
                    .css('left', draggerPosLeft + markerLeftPos);
                opts.$left.css({left: 0});
                opts.$center.css({left: 0});
                opts.$right.css({left: opts.$center.width()});

                context._scaleScrubBar(opts);
                opts.$leftShade.width(context._getLeftPos(opts.$dragger) + 7.5);
            },
        });
        opts.$dragger.draggable({
            axis: 'x',
            containment: container,
            handle: '.scrub-control-bar-center',
            start() {},
            drag() {
                opts.$leftShade.width(context._getLeftPos(opts.$dragger) + 7.5);
                const shadeLeft = context._getLeftPos(opts.$right) + context._getLeftPos(opts.$dragger) + 7.5;
                opts.$rightShade.css({
                    left: shadeLeft,
                    right: 0,
                    width: opts.$scaleContainer.width() - shadeLeft,
                });
                const clipScale = context.getClipScale.call(context);
                const valueleft =
                    clipScale * (context._getLeftPos(opts.$left) + context._getLeftPos(opts.$dragger) + 4.5);
                const valueright =
                    clipScale * (context._getLeftPos(opts.$right) + context._getLeftPos(opts.$dragger) + 4.5);

                context.setStartTime(valueleft);
                context.setEndTime(valueright);
            },
            stop() {
                context._scaleScrubBar(opts);
            },
        });

        //set start width to 100%
        setTimeout(function() {
            opts.$right.css({
                left: $container.width() - opts.$left.width(),
            });
            opts.$center.width($container.width() - opts.$left.width());
            opts.$dragger.width(opts.$left.width() + opts.$right.width() + opts.$center.width());
            opts.$leftShade.width(parseInt(opts.$dragger.css('left'), 10) + 7.5);
            opts.$rightShade.css({
                left: opts.$scaleContainer.width() - 7.5,
                right: 0,
                width: 7.5,
            });
            context._scaleScrubBar(opts);
            result.resolve();
        }, 300);

        return result;
    },
    modifierDown: false,
    videoKeyup(event) {
        const context = this;
        if (event.which === 18) {
            context.modifierDown = false;
        }
    },

    videoKeydown(event) {
        // guard is necessary because the event handler is somehow bound without init
        if (this.vidsvcs && this.vidsvcs.player){
            const _jwplayer = this.vidsvcs.player;
            const context = this;
            const videoScaleOpts = context.videoScaleOpts;
            const videoScrubOpts = context.videoScrubOpts;
            let increment = 5;
            if (event.which === 18) {
                context.modifierDown = true;
            }

            function vscale() {
                videoScaleOpts.$dragger.width(videoScaleOpts.$dragger.width() + increment);
                videoScaleOpts.$center.width(videoScaleOpts.$center.width() + increment);
                videoScaleOpts.$right.css('left', parseInt(videoScaleOpts.$right.css('left'), 10) + increment + 'px');
            }

            function vmove() {
                videoScaleOpts.$dragger.css('left', parseInt(videoScaleOpts.$dragger.css('left'), 10) + increment + 'px');
            }

            function selectHandle(handle) {
                handle
                    .toggleClass('selected')
                    .siblings()
                    .removeClass('selected');
                const selected = videoScrubOpts.$left.hasClass('selected');
                context.clipping.selected = selected ? handle : null;
            }

            if (
                $('#edit-panel').hasClass('panel-open') &&
                context.modifierDown &&
                !$('#modal-clip-name,#startTime,#endTime').is(':focus')
            ) {
                event.preventDefault();
                switch (event.which) {
                    case 37: //Move Right
                        if (videoScaleOpts.$scaleBlock.parent().scrollLeft() > 0) {
                            increment = -increment;
                            vmove();
                        }
                        break;
                    case 39: //Move Right
                        if (
                            videoScaleOpts.$scaleBlock.parent().scrollLeft() <=
                            videoScaleOpts.$scaleBlock.width() - videoScaleOpts.$scaleBlock.parent().width()
                        ) {
                            vmove();
                        }
                        break;
                    case 84:
                        //select or deselect right scrub handle ( 'r' )
                        $('#modal-clip-name')
                            .focus()
                            .select();
                        break;

                    case 187: //Scale Down
                        if (context.videoScrubScale > 0.1) {
                            increment = -increment;
                            vscale();
                        }

                        break;
                    case 189: //Scale Up
                        if (context.videoScrubScale <= 1) {
                            vscale();
                        }
                        break;
                }
                context._setVideoScalePos(
                    videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    videoScrubOpts,
                );
            } else if ($('#edit-panel').hasClass('panel-open') && !$('#modal-clip-name,#startTime,#endTime').is(':focus')) {
                event.preventDefault();
                const space = ' ';
                switch (event.key) {
                    case 'Tab':
                        //focus clipname
                        const title = $('#modal-clip-name')
                            .val()
                            .split('--'); //eslint-disable-line no-case-declarations
                        const count = $('#saved-clips ul li').length + 1; //eslint-disable-line no-case-declarations
                        $('#modal-clip-name')
                            .val(title[0] + ' -- ' + count)
                            .focus();
                        break;
                    case space: {
                        const playerState = _jwplayer.getState();

                        if (playerState === JWPlayerState.idle || playerState === JWPlayerState.paused) {
                            _jwplayer.play();
                            $('#player-play')
                                .addClass('fa-pause')
                                .removeClass('fa-play');
                        } else if (playerState === JWPlayerState.playing) {
                            _jwplayer.pause();
                            $('#player-play')
                                .addClass('fa-play')
                                .removeClass('fa-pause');
                        }
                        break;
                    }
                    case 'ArrowLeft': //Move left -1
                        context._skipWithVal(-1);
                        break;
                    case 'ArrowRight': //Move Right +5secs
                        context._skipWithVal(5);
                        break;
                    case 'c': // clip
                    case 'C':
                        $('#video-clip-save').click();
                        break;
                    case 'i':
                    case 'I':
                        context._moveLeftScrubMarker();
                        break;
                    case 'l':
                    case 'L':
                        $('#player-loop').click();
                        break;
                    case 'o':
                    case 'O':
                        context._moveRightScrubMarker();
                        break;
                    case 'r':
                    case 'R':
                        //select or deselect right scrub handle ( 'r' )
                        selectHandle(videoScrubOpts.$right);
                        break;
                }
            } else if (
                $('#edit-panel').hasClass('panel-open') &&
                event.which === 13 &&
                $('#modal-clip-name').is(':focus')
            ) {
                $('#video-clip-save').click();
                $('#modal-clip-name').focusout();
                $('#video-editor-fly-over').focus();
            } else if ($('#edit-panel').hasClass('panel-open') && event.which === 13 && $('#startTime').is(':focus')) {
                context.activePlayer.player('currentTime', $('#startTime').val());
                context._moveLeftScrubMarker(0, $('#startTime').val());
            }
        }
    },
    _skipWithVal(n) {
        const context = this;
        const $player = context.activePlayer;
        const time = this.vidsvcs.player.getCurrentTime();

        // occasionally, jwplayer().getCurrentTime() returns undefined
        if (time == null) {
            return;
        }

        $player.player('currentTime', time + n);
    },
    _moveLeftScrubMarker(n = 0, val) {
        const context = this;
        const $player = context.activePlayer;
        const videoScrubOpts = context.videoScrubOpts;
        const left = context._getLeftPos(videoScrubOpts.$handle) - context._getLeftPos(videoScrubOpts.$dragger);
        if (n !== 0 && !val) {
            const time = parseFloat(videoScrubOpts.$handle.attr('data-time'));
            $player.player('currentTime', time + n);
        } else if (val) {
            $('#curTime').val(parseInt($('#startTime').val(), 10));
            videoScrubOpts.$dragger
                .css('left', context._getLeftPos(videoScrubOpts.$handle) - 4.5)
                .width(videoScrubOpts.$dragger.width() - context._getLeftPos(videoScrubOpts.$handle));
            videoScrubOpts.$right.css('left', context._getLeftPos(videoScrubOpts.$right) - left + 4.5);
            videoScrubOpts.$center.width(
                context._getLeftPos(videoScrubOpts.$right) - context._getLeftPos(videoScrubOpts.$left),
            );
        } else {
            $('#startTime').val(parseFloat($('#curTime').val()));
            videoScrubOpts.$dragger
                .css('left', context._getLeftPos(videoScrubOpts.$handle) - 4.5)
                .width(videoScrubOpts.$dragger.width() - context._getLeftPos(videoScrubOpts.$handle));
            videoScrubOpts.$right.css('left', context._getLeftPos(videoScrubOpts.$right) - left + 4.5);
            videoScrubOpts.$center.width(
                context._getLeftPos(videoScrubOpts.$right) - context._getLeftPos(videoScrubOpts.$left),
            );
        }
    },
    _moveRightScrubMarker() {
        const context = this;
        const {
            _getLeftPos,
            videoScrubOpts: {
                $handle,
                $dragger,
                $left,
                $right,
                $center,
            },
        } = context;
        const left = _getLeftPos($handle) - _getLeftPos($dragger);

        $('#endTime')
            .sdaRemoveError()
            .val($('#curTime').val());
        $dragger.width($dragger.width() - _getLeftPos($handle));
        $right.css('left', left - 4.5);
        $center.width(
            _getLeftPos($right) - _getLeftPos($left),
        );
    },
    _inOutKeydown() {},
    _displayClipMessage(action) {
        switch (action) {
            case 'save clip':
                $('#clip-message').addClass('show');
                break;
            case 'pause':
            case 'stop':
                break;
        }
    },
    _instantClipSaveHandler(vModel) {
        const context = this;
        const currentUrl = window.location.href;
        const count = context.weather ? 1 : 10;
        context._displayClipMessage('save clip');
        if ($('#saved-clips ul li').length < count) {
            vModel.attributes.video.title = $('#modal-clip-name').val();

            const $li = $(clipCardTemplate(vModel.toJSON()));

            $('#saved-clips ul').append($li);
            $('#video-edit-close').attr('disabled', false);

            $li.addClass('clipping');

            delete vModel.id;
            delete vModel.attributes.video.uuid;
            delete vModel.attributes.video.externalID;

            vModel.attributes.video.original = 'true';
            vModel.set({inpoint: -1, outpoint: -1});
            vModel.save().done(function(model) {
                const clipModel = new context.VideoModel(model.data[0]);
                const clipCollection = context.savedClipCollection || new context.clipCollection();

                clipCollection.add(clipModel.toJSON());

                $li.replaceWith($(clipCardTemplate(clipModel.toJSON())));
                context.savedClipCollection = clipCollection;

                //story
                if (context.story && window.location.href === currentUrl) {
                    context.that._saveClipModel(clipModel, context.isNewscast);
                }
            });
        }
    },

    setClipName(name){
        $('#modal-clip-name').val(name);
    },

    _videoEditorSaveHandler(vModel) {
        const context = this;
        const currentUrl = window.location.href;
        const count = context.weather ? 1 : 10;
        context._displayClipMessage('save clip');
        if ($('#saved-clips ul li').length < count && ($('#startTime').val() || $('#endTime').val())) {
            const newModel = _.cloneDeep(vModel);
            newModel.attributes.video.title = $('#modal-clip-name').val();
            newModel.attributes.video.original = 'true';

            // If the user is clipping using the autoclipping segments, we set the caption to the text
            // for that segment, limited to 1024 chars.
            const lastEngagedSegmentText = (state.lastEngagedSegment && state.lastEngagedSegment.text) || undefined;
            let truncatedCaption = lastEngagedSegmentText || vModel.attributes.video.caption;
            if (truncatedCaption.length > 1024) {
                truncatedCaption = truncatedCaption.substring(0, 1021) + '...';
            }
            newModel.attributes.video.caption = truncatedCaption;

            const $li = $(clipCardTemplate(newModel.toJSON()));

            $('#saved-clips ul').append($li);
            $('#video-edit-close').attr('disabled', false);

            $li.addClass('clipping');

            delete newModel.id;
            delete newModel.attributes.video.uuid;
            delete newModel.attributes.video.externalId;

            if ($('#startTime').val()) {
                newModel.set({
                    inpoint: $('#startTime').val(),
                });
            }
            if ($('#endTime').val()) {
                newModel.set({
                    outpoint: $('#endTime').val(),
                });
            }

            newModel.save().done(function (model) {
                const data = model.data[0];
                if (!data || !model.success) {
                    $li.remove();
                    messageHandler(
                        'error',
                        `Failed to clip "${vModel.attributes.video.title}"`,
                        data ? data.msg : '',
                    );
                    return;
                }

                const vidUuid = data.video.uuid;
                newModel.id = vidUuid;
                newModel.attributes.video.uuid = vidUuid;
                newModel.attributes.video.externalId = data.video.externalId;
                const clipModel = new MediaModel({uuid: vidUuid});

                //story
                if (context.story && window.location.href === currentUrl) {
                    context.that._saveClipModel(clipModel, context.isNewscast);
                }

                if (lastEngagedSegmentText) {
                    analytics.logEvent({
                        category: 'Auto Clipper Segments Beta',
                        action: 'auto clip segment save',
                        label: `${vModel.attributes.video.title}`,
                    });
                }

                $li.replaceWith($(clipCardTemplate(newModel.toJSON())));
                BBFetch(clipModel)
                    .then(() => {
                        const clipCollection = context.savedClipCollection || new context.clipCollection();
                        clipCollection.add(clipModel);
                        context.savedClipCollection = clipCollection;
                    })
                    .catch(console.error);
            });
        }
    },
    _stopAllPlayers() {
        if (!this.model.attributes.video.externalId) {
            this.vidsvcs.player.stop();
        } else {
            this.activePlayer.player('stop');
        }
    },

    initSegmentHandlers(context, {firstName, lastName, homeStation}){
        const $segmentList = $('.segment-list');
        $segmentList.on('click', '.segment', function({currentTarget}){
            analytics.logEvent({
                category: 'Auto Clipper Segments Beta',
                action: 'list interaction',
                label: `${firstName} ${lastName} - ${homeStation}`,
            });

            // highlight current segment
            $segmentList.children().removeClass('active');
            currentTarget.classList.add('active');

            const markerWidth = 15;
            const storyData = state.segmentStories.find(s => s.id === currentTarget.id);
            state.lastEngagedSegment = storyData;

            const title = storyData.title;
            const startTime = parseFloat(storyData.startTime);
            const endTime = parseFloat(storyData.endTime);
            const duration = context.clipDuration;
            // the size of the outer block can be treated like a timeline for the video
            const $container = $('.scale-block');
            // red line between the left and right marker
            const $center = $container.find('.scrub-control-bar-center');
            // element surrounding left and right markers and center
            const $dragger = $container.find('.scrub-control-bar-drag');
            const $leftShade = $container.find('.scrub-left-shade');
            const $leftMarker = $container.find('.scrub-control-bar-left-marker');
            const $rightMarker = $container.find('.scrub-control-bar-right-marker');
            const $rightShade = $container.find('.scrub-right-shade');
            const $handle = $container.find('.scrub-control-bar-handle');

            const containerWidth = $container.width();
            const leftMarkerPos = (startTime / duration) * containerWidth - markerWidth / 2;
            const rightMarkerPos = Math.min((endTime / duration) * containerWidth, containerWidth) - markerWidth / 2;
            const centerWidth = rightMarkerPos - leftMarkerPos;

            $center.css({
                width: `${centerWidth}px`,
            });
            $dragger.css({
                width: `${centerWidth + markerWidth * 2}px`,
                left: `${leftMarkerPos}px`,
            });
            $leftMarker.css({left: 0});
            $rightMarker.css({left: `${centerWidth}px`});

            $leftShade.css({width: `${leftMarkerPos + markerWidth / 2}px`});
            $rightShade.css({
                width: `${containerWidth - rightMarkerPos}px`,
                left: `${leftMarkerPos + centerWidth + markerWidth / 2}px`,
                right: 0,
            });

            context.setClipName(title + ' - clip');
            context.setStartTime(startTime);
            context.setEndTime(endTime);
            context._scaleScrubBar({$dragger, $right: $rightMarker, $leftShade, $center, $handle});
        });
    },

    _initVideoEvents(data) {
        const initialPackageId = _.get(data, 'vModel.attributes.video.uuid', null);
        const context = this;
        const $player = context.activePlayer;
        const _jwplayer = this.vidsvcs.player;

        const opts = {
            $skipB: $('#player-skip-back'),
            $play: $('#player-play'),
            $skipF: $('#player-skip-forward'),
            $loop: $('#player-loop'),
            $curTime: $('#curTime'),
            $startTime: $('#startTime'),
            $endTime: $('#endTime'),
            $setIn: $('#set-in-point'),
            $setOut: $('#set-out-point'),
            $jumpS: $('#jump-to-start'),
            $jumpE: $('#jump-to-end'),
            $saveBtn: $('#video-clip-save'),
            $instantClipBtn: $('#video-instant-clip-save'),
            $cancelBtn: $('#video-edit-cancel'),
            $doneBtn: $('#video-edit-close'),
            $deleteClip: $('.clip-remove'),
        };
        $('#edit-panel').off('click');
        $('#edit-panel').on('click', '.clip-remove', function() {
            const $caller = $(this);
            const $parent = $caller.parents('li');
            const uuid = $parent.attr('id');

            const model = context.savedClipCollection.find(clip => {
                const json = clip.toJSON();
                return json.uuid === uuid || (json.video && json.video.uuid === uuid);
            });

            eventChannels.media.videoEditor.trigger('delete.clip', model);
            if (!context.story) {
                model.destroy();
            }

            $parent.remove();
        });

        opts.$jumpS.off('click');
        opts.$jumpS.click(function() {
            const time = parseFloat($('#startTime').val());
            $player.player('currentTime', time);
            return false;
        });

        opts.$jumpE.off('click');
        opts.$jumpE.click(function() {
            const time = parseFloat($('#endTime').val());
            $player.player('currentTime', time);
            return false;
        });

        opts.$setIn.off('click');
        opts.$setIn.click(function() {
            context._moveLeftScrubMarker();
        });

        opts.$setOut.off('click');
        opts.$setOut.click(function() {
            context._moveRightScrubMarker();
        });

        opts.$saveBtn.off('click');
        opts.$saveBtn.click(function() {
            const start = parseFloat(opts.$startTime.val());
            const end = parseFloat(opts.$endTime.val());
            if (start === 0 && end === context.clipDuration) {
                return;
            }
            if (end <= start) {
                opts.$endTime.sdaError('end not after start');
                return;
            }
            makesClip(initialPackageId);
            context._videoEditorSaveHandler(data.vModel);
        });

        opts.$instantClipBtn.off('click');
        opts.$instantClipBtn.click(function() {
            makesInstantClip(initialPackageId);
            context._instantClipSaveHandler(data.vModel);
        });

        opts.$doneBtn.off('click');
        opts.$doneBtn.click(function() {
            context._stopAllPlayers();
            if (context.isNewscast) {
                eventChannels.media.videoEditor.trigger('done.clipping');
                $('#video-editor-fly-over ').close();
                if (!context.story && !context.weather) {
                    context.that.showNavPanel();
                }
            } else {
                $('.video-editor-wrapper').removeClass('video-edit');
            }
            if ($('.clip-list li').length) {
                if (!context.story) {
                    context.selectedId = $('.clip-list li:first').attr('id');
                    $('.clip-list li').empty();
                }
            }
            $('#edit-panel').close();
            context.that.videoModel = context.model;
        });

        opts.$cancelBtn.off('click');
        opts.$cancelBtn.click(function() {
            if (context.isNewscast) {
                eventChannels.media.videoEditor.trigger('cancel');
                $('#video-editor-fly-over ').close();
                if (!context.story && !context.weather) {
                    context.that.showNavPanel();
                }
            } else {
                $('.video-editor-wrapper').removeClass('video-edit');
            }
            $('.video-editor-wrapper').removeClass('video-edit');
            if ($('.clip-list li').length) {
                $('.filter-option').removeClass('selected');
                $('.filter-list li:first-child a').addClass('selected');
            }
            $('#edit-panel').close();
            context._stopAllPlayers();
        });

        opts.$skipF.off('click');
        opts.$skipF.click(function() {
            $player.player('currentTime', data.duration);
        });

        opts.$play.off('click');
        opts.$play.click(function() {
            if ($(this).hasClass('fa-play')) {
                $player.player('play');
            } else {
                $player.player('pause');
            }
        });

        opts.$skipB.off('click');
        opts.$skipB.click(function() {
            $player.player('currentTime', 0);
        });

        opts.$loop.off('click');
        opts.$loop.click(function() {
            $(this).toggleClass('active');
            _jwplayer.setConfig({
                repeat: $(this).hasClass('active'),
            });
        });

        _jwplayer.on('play', () =>
            $('#player-play')
                .removeClass('fa-play')
                .addClass('fa-pause'),
        );

        _jwplayer.on('pause', () =>
            $('#player-play')
                .removeClass('fa-pause')
                .addClass('fa-play'),
        );

        _jwplayer.on('time', ({duration: _duration}) => {
            const duration = Math.abs(_duration);
            const position = _jwplayer.getCurrentTime();

            $('#curTime').val(position);

            const scale = $('.scale-block').width() / duration;

            $('.scrub-control-bar-handle')
                .css({
                    left: position * scale,
                    'z-index': 3,
                })
                .attr({
                    'data-scale': scale,
                    'data-left': position * scale,
                    'data-time': position,
                    'data-duration': duration,
                });
        });
    }, //scrub-control-bar-handle
    _getDragOpts(el) {
        let opts;

        const $scrubContainer = $('.scale-block');
        const scrubOpts = {
            $scaleContainer: $('.video-scrub-control-bar'),
            $right: $scrubContainer.find('.scrub-control-bar-right-marker'),
            $left: $scrubContainer.find('.scrub-control-bar-left-marker'),
            $center: $scrubContainer.find('.scrub-control-bar-center'),
            $dragger: $scrubContainer.find('.scrub-control-bar-drag'),
            $scaleBlock: $scrubContainer,
            $leftShade: $scrubContainer.find('.scrub-left-shade'),
            $rightShade: $scrubContainer.find('.scrub-right-shade'),
            $handle: $('.scrub-control-bar-handle'),
        };
        if (el === 'scale') {
            const container = '.video-scale-wrapper';
            const $container = $(container);

            opts = {
                $container,
                $scaleContainer: $('.video-scale-control-bar'),
                $right: $container.find('.control-bar-right-marker'),
                $left: $container.find('.control-bar-left-marker'),
                $center: $container.find('.control-bar-center'),
                $dragger: $container.find('.control-bar-drag'),
                $scaleBlock: $container.find('.scale-block'),
            };
        } else {
            opts = scrubOpts;
        }

        return opts;
    },

    _initScaleBar() {
        const context = this;
        const container = '.video-scale-wrapper';
        const $container = $(container);
        const opts = context._getDragOpts('scale');
        const scrubOpts = context._getDragOpts('scale');
        const result = $.Deferred();

        context.videoScaleOpts = opts;

        opts.$right.draggable({
            axis: 'x',
            containment: container,
            drag(event, ui) {
                opts.$center.css({
                    width: ui.position.left - opts.$left.width(),
                });
                opts.$dragger.width(ui.position.left + opts.$right.width());
                //set min width
                if (ui.position.left - context._getLeftPos(opts.$left) <= 75) {
                    return false;
                }
                context._setVideoScalePos(
                    context.videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    scrubOpts,
                );
                return true;
            },
            stop() {
                context._setVideoScalePos(
                    context.videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    scrubOpts,
                );
            },
        });

        opts.$left.draggable({
            axis: 'x',
            containment: container,
            drag(event, ui) {
                opts.$center.width(context._getLeftPos(opts.$right) - ui.position.left - opts.$left.width()).css({
                    left: ui.position.left + opts.$left.width(),
                });
                //set min width
                if (context._getLeftPos(opts.$right) - ui.position.left <= 75) {
                    return false;
                }
                context._setVideoScalePos(
                    context.videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    scrubOpts,
                );
                return true;
            },
            stop(event, ui) {
                opts.$dragger.width(opts.$left.width() + opts.$right.width() + opts.$center.width()).css({
                    left: context._getLeftPos(opts.$dragger) + ui.position.left,
                });
                opts.$left.css({
                    left: 0,
                });
                opts.$right.css({
                    left: opts.$center.width() + opts.$left.width(),
                });
                opts.$center.css({
                    left: opts.$left.width(),
                });
                context._setVideoScalePos(
                    context.videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    scrubOpts,
                );
            },
        });
        opts.$dragger.draggable({
            axis: 'x',
            containment: container,
            handle: '.control-bar-center',
            drag() {
                context._setVideoScalePos(
                    context.videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    scrubOpts,
                );
            },
            stop() {
                context._setVideoScalePos(
                    context.videoScaleOpts,
                    context.scaleBlockHeight,
                    context.scaleBlockWidth,
                    scrubOpts,
                );
            },
        });

        //set start width to 100%
        setTimeout(function() {
            const deferred = context._initScrubBar();
            deferred.done(function() {
                opts.$right.css({
                    left: $container.width() - opts.$right.outerWidth(),
                });
                opts.$center.width($container.width() - opts.$left.width() - opts.$right.width());
                opts.$dragger.width(opts.$left.width() + opts.$right.width() + opts.$center.width());

                context.scaleBlockHeight = opts.$scaleBlock.height();
                context.scaleBlockWidth = $container.width();
                context._initScrubBar();
            });

            result.resolve();
        }, 500);

        return result;
    },

    _openVideoEditorPanel() {
        $('#edit-panel').open();
        $('.video-editor-wrapper').addClass('video-edit');

        return false;
    },
    openVideoFlyover(vModel, hasPermission) {
        const context = this;
        let clipData;

        if (hasPermission && context.model.attributes.video.externalId) {
            if (context.model.type === 'newscast') {
                context._openVideoEditorPanel();
            }
            clipData = {
                thumbCount: 20,
                thumbs: [],
            };

            beforeMainLoader();

            $.getJSON(
                'https://content.uplynk.com/player/assetinfo/' +
                    context.model.attributes.video.externalId +
                    '.json',
                data => {
                    context.videoData = data;
                    context.videoData.vModel = vModel;
                    clipData.duration = data.duration;
                    clipData.thumbCount = data.duration / data.slice_dur;

                    clipData.thumbs = generateThumbnails(data);
                },
            )
                .then(() => {
                    completeMainLoader();
                    $(window).resize(function() {
                        context._videoWindowResize();
                    });
                    clipData.thumbWidth = $('.scale-block').width() / clipData.thumbCount;
                    const width = 100 / clipData.thumbCount;
                    const height = 40;
                    clipData.thumbs = clipData.thumbs.map(thumb => ({...thumb, width, height}));

                    $('.scale-block .video-clipping-thumbs').html(videoThumbsTemplate(clipData));
                    $('#startTime,#curTime').val('0.00');
                    $('#endTime')
                        .sdaRemoveError()
                        .val(clipData.duration);
                    context.clipDuration = clipData.duration;

                    return clipData;
                })
                .then(() => {
                    context._initScaleBar().then(() => {
                        context.playerUrl = context.model.attributes.video.externalId
                            ? context.model.attributes.video.url
                            : context.model.attributes.video.mp4Url;

                        if (context.model.type === 'newscast') {
                            context._openVideoEditorPanel();
                        }

                        const remainderHeight =
                            $('.video-scale-wrapper').height() + $('.video-editor-bottom').outerHeight();

                        $('#video-editor-fly-over')
                            .find('.video-editor-wrapper')
                            .addClass('editor')
                            .addClass('show-video')
                            .outerWidth($('#video-editor-fly-over').width() - $('.modal-media-container').width());

                        $('#video-editor-fly-over')
                            .find('.sda-media-editor')
                            .width('auto')
                            .height($('.video-editor-wrapper').height() - remainderHeight);

                        const fileUrl = context.playerUrl;
                        const thumbUrl = context.model.attributes.video.thumbUrl;
                        const vttFile = base64Encode(generateVTT(clipData.thumbs));
                        const playerConfig = vttFile
                            ? {tracks: [{file: 'data:text/plain;base64,' + vttFile, kind: 'thumbnails'}]}
                            : {};

                        $('#video-editor-fly-over')
                            .find('.sda-media-editor')
                            .player('load', fileUrl, thumbUrl, playerConfig);

                        context.activePlayer = $('.editor');

                        context._initVideoEvents(context.videoData);

                        $('.editor').bind(context.vidsvcs.events.PLAYER_STATE_CHANGED, function(e, arg) {
                            let i = clipData.duration + 1;
                            const $player = context.activePlayer;

                            $('.scrub-control-bar-handle').attr({
                                'data-scale': 1,
                                'data-left': 0,
                                'data-time': 0,
                                'data-duration': clipData.duration,
                            });
                            context.playerState = arg;
                            if (context.playerState === 'play') {
                                $('#player-play').addClass('fa-pause');
                                $('#player-play').removeClass('fa-play');
                            }
                            if (context.playerState === 'pause') {
                                $('#player-play').removeClass('fa-play ');
                                $('#player-play').addClass('fa-play');
                            }

                            function getPlayerTime(j) {
                                const scale = $('.scale-block').width() / clipData.duration;

                                if (context.playerState === 'play') {
                                    if (
                                        $('#player-play').hasClass('fa-pause') ||
                                        !$('#player-play').hasClass('fa-play')
                                    ) {
                                        $('#player-play').addClass('fa-pause');
                                        $('#player-play').removeClass('fa-play');
                                    }
                                    if (j <= clipData.duration) {
                                        if ($('#player-loop').hasClass('active') && j >= $('#endTime').val()) {
                                            $player.player('currentTime', parseFloat($('#startTime').val()));
                                        }
                                        const _j = $player.player('currentTime');

                                        $('.scrub-control-bar-handle')
                                            .css({
                                                left: j * scale,
                                                'z-index': 3,
                                            })
                                            .attr({
                                                'data-scale': scale,
                                                'data-left': _j * scale,
                                                'data-time': _j,
                                                'data-duration': clipData.duration,
                                            });
                                        $('#curTime').val(Math.round(_j * 10000) / 10000);

                                        setTimeout(function() {
                                            getPlayerTime(_j);
                                        }, 50);
                                    }
                                } else {
                                    $('.scrub-control-bar-handle').attr({
                                        'data-scale': scale,
                                        'data-left': j * scale,
                                        'data-time': j,
                                        'data-duration': clipData.duration,
                                    });
                                }
                            }
                            switch (arg) {
                                case 'play':
                                    i = context.i || $player.player('currentTime');
                                    getPlayerTime(i);
                                    break;
                                case 'pause':
                                case 'stop':
                                    context.playerState = arg;
                                    break;
                                default:
                                    $('.scrub-control-bar-handle').css({
                                        'z-index': 0,
                                    });
                            }
                        });
                    });
                });

            if (this.that.userModel.debugModel.getFeatureFlag('labsSegments')){
                fetchSegments(vModel.id)
                    .then(({stories, status}) => {
                        state.segmentStories = stories;

                        const $container = $('#segments-panel');

                        if (status === 'PENDING') {
                            $container.append(segmentsPanel({pending: true}));
                        } else if (status === 'ERROR') {
                            $container.append(segmentsPanel({error: true}));
                        } else if (stories.length){
                            const segments = stories.map(story => {
                                const d = moment.duration(story.endTime - story.startTime, 'seconds');
                                const s = moment.duration(story.startTime, 'seconds');
                                const e = moment.duration(story.endTime, 'seconds');
                                const duration = formatDuration('' + d.minutes(), '' + d.seconds());
                                const startTime = formatDuration('' + s.minutes(), '' + s.seconds());
                                const endTime = formatDuration('' + e.minutes(), '' + e.seconds());

                                return {title: story.title, id: story.id, duration, startTime, endTime};
                            });

                            $container.append(segmentsPanel({segments}));
                            this.initSegmentHandlers(context, this.model.userModel.get('user'));
                        }
                    })
                    .catch(() => console.log(`Unable to fetch segment data for broadcast ${vModel.id}`));
            }
        } else {
            context.playerUrl = context.model.attributes.video.externalId
                ? context.model.attributes.video.url
                : context.model.attributes.video.mp4Url;
            if (context.model.type === 'newscast') {
                context._openVideoEditorPanel();
            }
            $('#sda-media-player-jw').css('width', '100%');

            const fileUrl = context.playerUrl;
            const thumbUrl = context.model.attributes.video.thumbUrl;

            const protocol = 'https:' === document.location.protocol ? 'https:' : 'http:';

            const player = jwplayer('sda-media-player-jw').setup({
                file: fileUrl,
                image: thumbUrl,
                width: '100%',
                skin: protocol + '//videobase.sinclairstoryline.com/skins/defaultSkin.xml',
            });

            player.onReady(() => {
                const remainderHeight = $('.video-scale-wrapper').height() + $('.video-editor-bottom').outerHeight();

                $('#sda-media-player-jw')
                    .css({
                        width: '100%',
                    })
                    .height(
                        ($('#video-editor-fly-over')
                            .find('.video-editor-wrapper')
                            .width() /
                            16) *
                            9,
                    );

                $('#video-editor-fly-over')
                    .find('.video-editor-wrapper')
                    .width($(window).width() - 358)
                    .css('padding', 0);

                $('#video-editor-fly-over')
                    .find('.sda-media-editor')
                    .width('auto')
                    .css({
                        'margin-top': 0,
                        opacity: 1,
                    })
                    .height($('.video-editor-wrapper').height() - remainderHeight);

                $('#video-editor-fly-over')
                    .find('.sda-media-editor')
                    .player('load', fileUrl, thumbUrl);
            });
        }

        return false;
    },
};

export default clipping;
